import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { putNotifyNotificationContentDeactivated } from "../../../queries/notify";
import { buildNotifyInfiniteNotificationContentQueryKey } from "./useInfiniteNotificationContent";
import { buildNotifyContentDetailsQueryKey } from "./useNotifyContent";

interface IUseNotifyNotificationContentAction {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useNotifyNotificationContentDeactivate({
  onSuccess,
  onError,
}: IUseNotifyNotificationContentAction = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [deactivateNotificationContentMutation, { isLoading: isDeactivateNotificationContentLoading }] = useMutation(
    putNotifyNotificationContentDeactivated(networkHeaders),
    {
      onSuccess: async (_, id) => {
        // Add relevant query invalidations here based on your data structure
        await queryCache.invalidateQueries(
          buildNotifyContentDetailsQueryKey({
            id,
          }),
        );
        setTimeout(async () => {
          await queryCache.invalidateQueries(buildNotifyInfiniteNotificationContentQueryKey());
        }, 1000);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: onError,
    },
  );

  const deactivateNotificationContent = async (id: number) => {
    return await deactivateNotificationContentMutation(id);
  };

  return { deactivateNotificationContent, isDeactivateNotificationContentLoading };
}
